import { produce } from 'immer'
import type { State } from '../typings'
import { openAction } from './openAction'
import type { IEntityAppointment } from '@user/store/scheduling'
import { ScheduleMode } from '@user/components/Scheduling/typings'

export type RescheduleAction = {
  type: 'reschedule'
  payload: IEntityAppointment
}

export const rescheduleAction = (
  state: State,
  payload: RescheduleAction['payload'],
): State => {
  const { billingType, appointmentType } = payload

  const mode: ScheduleMode =
    appointmentType === 'Estimate'
      ? billingType === 'Free'
        ? 'free'
        : 'paid'
      : 'service'

  const intialState = openAction(state, {
    mode,
    screen: 'filters',
  })

  return produce(intialState, (draft) => {
    draft.appointment = payload
  })
}

export const rescheduleActionCreator = (
  payload: IEntityAppointment,
): RescheduleAction => ({
  type: 'reschedule',
  payload,
})
